import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Box,
  Typography,
  Button,
  useTheme,
} from '@mui/material'
import {
  Home as HomeIcon,
  ArrowBack as BackIcon,
} from '@mui/icons-material'

const NotFound: React.FC = () => {
  const theme = useTheme()
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate('/')
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 4,
        }}
      >
        {/* 404 Illustration */}
        <Box
          sx={{
            fontSize: '8rem',
            fontWeight: 'bold',
            color: theme.palette.primary.main,
            lineHeight: 1,
            mb: 2,
          }}
        >
          404
        </Box>

        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ fontWeight: 'bold', color: 'text.primary' }}
        >
          Page Not Found
        </Typography>

        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ mb: 4, maxWidth: 500 }}
        >
          Sorry, we couldn't find the page you're looking for. 
          The page might have been moved, deleted, or you might have entered the wrong URL.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            size="large"
          >
            Go to Home
          </Button>

          <Button
            variant="outlined"
            startIcon={<BackIcon />}
            onClick={handleGoBack}
            size="large"
          >
            Go Back
          </Button>
        </Box>

        {/* Bee-themed decoration */}
        <Box
          sx={{
            mt: 6,
            opacity: 0.3,
            fontSize: '2rem',
          }}
        >
          🐝
        </Box>
      </Box>
    </Container>
  )
}

export default NotFound
